import { ca } from '@cian/analytics';

export function trackDeleteOffer(offerId: number, gaLabel: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'Remove',
    label: gaLabel,
    products: [{ id: offerId, objectType: 'offer' }],
    page: { type: 'ListingCompare', siteType: 'desktop' },
  });
}
